import { Fragment } from "react";
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import VehicleMaintenance from "./VehicleMaintenance";
import { useParams } from "react-router-dom";

const VehicleMaintenanceWrapper = () => {
    const { id } = useParams<{ id: string }>();

    // Default filters for vehicle maintenance
    const defaultFilterFilters = {
        vehicle_id: id // Always filter by the current vehicle
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilterFilters}>
                <VehicleMaintenance />
            </FiltersProvider>
        </Fragment>
    );
};

export default VehicleMaintenanceWrapper;